<div class="modal-header">
  <h4 class="modal-title">{{ 'agents.intentionModal.title' | translate }}</h4>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="onCancel()"></button>
</div>

<div [formGroup]="formGroup" class="modal-body">
  <div class="px-2 mt-3 col-12">
    <div>
      <label class="form-label">{{ 'agents.intentionModal.selectChannel' | translate }}</label>
      <select 
        class="form-select" 
        [formControlName]="'channel'"
        (change)="onSelectChannel($event)"
        name="channel"
        [ngClass]="{'is-invalid': formGroup.get('channel')?.invalid && formGroup.get('channel')?.touched}"
      >
        <option value="">{{ 'agents.intentionModal.selectPlaceholder' | translate }}</option>
        @for (item of channelRef; track $index) {
        <option [value]="item._id">{{ item.name }}</option>
        }
      </select>
      @if (formGroup.get('channel')?.invalid && formGroup.get('channel')?.touched) {
        <div class="invalid-feedback d-block">{{ 'agents.intentionModal.channelRequired' | translate }}</div>
      }
    </div>
    <div class="mt-3">
      <label class="form-label">{{ 'agents.intentionModal.selectDepartment' | translate }}</label>
      <select 
        class="form-select" 
        [formControlName]="'department'"
        (change)="onSelectDepartment($event)"
        name="department"
        [ngClass]="{'is-invalid': formGroup.get('department')?.invalid && formGroup.get('department')?.touched}"
      >
      <option value="">{{ 'agents.intentionModal.selectPlaceholder' | translate }}</option>
        @for (item of departments; track $index) {
          <option [value]="item._id">{{ item.name }}</option>
        }
      </select>
      @if (formGroup.get('department')?.invalid && formGroup.get('department')?.touched) {
        <div class="invalid-feedback d-block">{{ 'agents.intentionModal.departmentRequired' | translate }}</div>
      }
    </div>

    <div class="mt-3">
      <label class="form-label">{{ 'agents.intentionModal.selectAgent' | translate }}</label>
      <select 
        class="form-select" 
        [formControlName]="'user'"
        (change)="onSelectUser($event)"
        name="user"
      >
        <option value="">{{ 'agents.intentionModal.selectPlaceholder' | translate }}</option>
        @if (users.length > 0) {
          @for (item of users; track item._id) {
            <option [value]="item._id">{{ item.name }}</option>
          }
        }
      </select>
    </div>
    <div class="mt-3 mb-3">
      <label class="form-label">{{ 'agents.intentionModal.whenToUse' | translate }}</label>
      <textarea
        class="form-control"
        [formControlName]="'details'"
        name="details"
        rows="5"
        [placeholder]="'agents.intentionModal.detailsPlaceholder' | translate"
        maxlength="512"
        [ngClass]="{'is-invalid': formGroup.get('details')?.invalid && formGroup.get('details')?.touched}"
      ></textarea>
      @if (formGroup.get('details')?.invalid && formGroup.get('details')?.touched) {
        <div class="invalid-feedback d-block">{{ 'agents.intentionModal.detailsRequired' | translate }}</div>
      }
      <span class="font-12 text-muted float-end">
        {{ formGroup.get('details')?.value?.length || 0 }}/512
      </span>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="onCancel()">
    {{ 'agents.intentionModal.cancel' | translate }}
  </button>
  <button
    type="submit"
    class="btn btn-primary"
    (click)="onSave()"
    [disabled]="formGroup.invalid || saving"
  >
    {{ (editMode ? 'agents.intentionModal.update' : 'agents.intentionModal.save') | translate }}
    @if (saving) {
      <mat-spinner
        [diameter]="25"
        [color]="'accent'"
        mode="indeterminate"
      />
    }
  </button>
</div>
